var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filled/Pencil"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IconVector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8336 11.6517C50.6118 8.42983 45.3882 8.42984 42.1664 11.6517L39 14.818L57.182 33L60.3483 29.8336C63.5702 26.6118 63.5702 21.3882 60.3483 18.1664L53.8336 11.6517Z",
    fill: "#033272"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 36.182L35.818 18L12.1664 41.6517C10.6192 43.1988 9.75 45.2973 9.75 47.4853V60C9.75 61.2427 10.7574 62.25 12 62.25H24.5147C26.7028 62.25 28.8012 61.3808 30.3484 59.8336L54 36.182ZM18 42.182L29.818 54L27.1664 56.6517C26.4631 57.3549 25.5093 57.75 24.5147 57.75H20.432L14.25 51.568V47.4853C14.25 46.4907 14.6451 45.5369 15.3483 44.8336L18 42.182Z",
    fill: "#033272"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.1889ae0c1618ea25d80541ec84d40a98.svg";
export { ForwardRef as ReactComponent };